import * as React from "react";
const SvgPlus = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 4V12M12 8H4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
export { SvgPlus as ReactComponent };
